export enum INTEGRATION_PLATFORM {
  MICROSOFT = 'microsoft_calendar',
  GOOGLE = 'google_calendar',
  CALENDLY = 'calendly',
  TEAMS = 'teams_chat',
  SLACK = 'slack_chat',
  MICROSOFT_EMAIL = 'microsoft_email',
  GOOGLE_EMAIL = 'google_email',
  LINKEDIN = 'linkedin',
  CIRCLEBACK = 'circleback',
  FATHOM = 'fathom',
  READ = 'read',
  NOTION = 'notion',
  BYNDER = 'bynder',
  SALESFORCE = 'salesforce',
  HUBSPOT = 'hubspot',
  APOLLO = 'apollo',
  HEYGEN = 'heygen',
  GOOGLE_SHEETS = 'google_sheets',
  VECTOR = 'vector',
  GOOGLE_DRIVE = 'google_drive',
  HEYREACH = 'heyreach',
  LUSHA = 'lusha',
  FULLENRICH = 'fullenrich',
  HUNTER = 'hunter',
  SEAMLESS = 'seamless',
  LEADIQ = 'leadiq',
  EXA = 'exa',
  GAMMA = 'gamma',
}

const SLACK_APP_CLIENT_ID = '6973649201331.7465824270647';
const SLACK_BOT_SCOPES = [
  'channels:join',
  'channels:history',
  'channels:read',
  'chat:write',
  'dnd:read',
  'emoji:read',
  'files:read',
  'files:write',
  'groups:history',
  'groups:read',
  'im:history',
  'im:read',
  'im:write',
  'mpim:history',
  'mpim:read',
  'mpim:write',
  'pins:read',
  'pins:write',
  'reactions:read',
  'reactions:write',
  'team:read',
  'usergroups:read',
  'users:read',
  'users:write',
  'users:read.email',
];

/** Direct OAuth installation URL for the Slack app configured on the production Azure bot. */
export const SLACK_INSTALL_URL = `https://slack.com/oauth/v2/authorize?${new URLSearchParams({
  client_id: SLACK_APP_CLIENT_ID,
  scope: SLACK_BOT_SCOPES.join(','),
}).toString()}`;

export const TIME_FILTER_OPTIONS = [
  {
    label: '1 day',
    value: '1d',
  },
  {
    label: '7 days',
    value: '7d',
  },
  {
    label: '14 days',
    value: '14d',
  },
  {
    label: '1 month',
    value: '1m',
  },
  {
    label: 'Last 90 days',
    value: '90d',
  },
  {
    label: 'Month-to-Date',
    value: 'mtd',
  },
  {
    label: 'Quarter-to-Date',
    value: 'qtd',
  },
  {
    label: 'Previous Month',
    value: 'prev_month',
  },
  {
    label: 'Previous Quarter',
    value: 'prev_quarter',
  },
];

/** True for a `value` offered in {@link TIME_FILTER_OPTIONS}. */
export const isTimeFilterOption = (value: unknown): value is string => (
  typeof value === 'string' && TIME_FILTER_OPTIONS.some(option => option.value === value)
);

export enum INTEGRATIONS_CONFIGURATION_PLATFORM {
  GOOGLE_CALENDAR = 'google-calendar',
  SALESFORCE = 'salesforce',
  HUBSPOT = 'hubspot',
  MICROSOFT = 'microsoft',
  APOLLO = 'apollo',
  NOTION = 'notion',
  BYNDER = 'bynder',
  GOOGLE_DRIVE = 'google-drive',
}

export enum INTEGRATIONS_MAPPING_TYPE {
  COMPANY = 'company',
  PERSON = 'person',
  EMAIL = 'email',
  CALL = 'call',
  ENRICHMENT = 'enrichment',
  CONTACT = 'contact',
}

export enum INTEGRATIONS_WEBHOOK_PLATFORM {
  CIRCLEBACK = 'circleback',
  FATHOM = 'fathom',
  READ = 'read',
  HEYREACH = 'heyreach',
  GONG = 'gong',
  FIREFLIES = 'fireflies',
}
